var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 12.152,
    width: 14.722,
    viewBox: "0 0 14.722 12.152",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.232 8.223c.257.1.437.1.538 0l2.117-2.211c.242-.247.068-.676-.266-.676H.38c-.34 0-.508.43-.265.676z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.13.113C7.099-.109 6.02-.007 4.94.432a4.699 4.699 0 00-2.49 2.295c-.524 1.055-.727 2.353-.659 3.88a.626.626 0 101.25-.054c-.062-1.385.13-2.47.527-3.272.397-.801.982-1.342 1.842-1.691 1.78-.723 3.239-.415 4.764 1.047a.625.625 0 10.865-.903C10.15.881 9.164.336 8.131.114zM12.395 4.973a.625.625 0 00-.616.632c0 1.376-.22 2.461-.613 3.26-.393.8-.942 1.326-1.715 1.66-1.617.7-3.12.498-4.793-.703a.625.625 0 10-.728 1.016c1.93 1.385 4.032 1.696 6.02.836 1.03-.446 1.831-1.226 2.34-2.258.507-1.032.74-2.304.74-3.81a.625.625 0 00-.635-.633z",
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontFeatureSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    },
    fontWeight: 400,
    fontFamily: "sans-serif",
    overflow: "visible",
    fill: "currentColor",
    fillRule: "evenodd"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.49 4.486a.377.377 0 00-.538 0l-2.116 2.21c-.243.247-.069.677.265.677h4.241c.341 0 .508-.43.265-.676z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch);
export default __webpack_public_path__ + "static/media/switch.4a1e1add.svg";
export { ForwardRef as ReactComponent };